import React from 'react';
import CartIcon from '../../icons/cart-icon.svg';
import styled from 'styled-components';
import { getContrastColorFrom } from '../../common/colors';
import { cartStateSelector, openCartModal } from '../../features/cart';
import { useAppDispatch, useAppSelector } from '../../core/hooks';
import Spinner from '../reusable/spinner/Spinner';
import useTranslate from '../../i18n/useTranslate';
import { useWidgetsTheme as theme } from '../../core/theme';

const CartPreviewButton = () => {
  const { cart, isLoadingCart } = useAppSelector(cartStateSelector);
  const actionColor = theme('actionColor');
  const { i18n } = useTranslate();
  const dispatch = useAppDispatch();

  const cartIconClick = () => dispatch(openCartModal());
  const gotItemsOnCart = !isLoadingCart && !!cart?.items.length;
  const badgeTextColor = getContrastColorFrom(actionColor);
  const iconLabel = isLoadingCart
    ? i18n('cart_loading')
    : i18n('cart_iconLabel', { quantity: cart?.items.length?.toString() ?? '0' });

  return (
    <>
      <CartIconContainer
        size={theme('cartIconSize')}
        role='button'
        aria-label={iconLabel}
        onClick={cartIconClick}
        iconColor={theme('cartIconColor')}
      >
        <CartIcon />
        <BadgeContainer>
          <CartButtonBadge badgeColor={actionColor} visible={gotItemsOnCart}>
            <svg viewBox='0 0 9 9' width='100%' height='100%'>
              <text x='50%' y='60%' dominantBaseline='middle' textAnchor='middle' fill={badgeTextColor}>
                {cart?.items.length}
              </text>
            </svg>
          </CartButtonBadge>
          <Spinner visible={isLoadingCart} backgroundColor={actionColor} spinnerColor={theme('cartIconColor')} />
        </BadgeContainer>
      </CartIconContainer>
    </>
  );
};

interface CartIconContainerProps {
  size: string;
  iconColor: string;
}
const CartIconContainer = styled.div<CartIconContainerProps>`
  display: inline-block;
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  position: relative;
  background-color: transparent;
  &:hover {
    cursor: pointer;
  }
  > svg path {
    stroke: ${(props) => props.iconColor};
  }
`;

const BadgeContainer = styled.div`
  position: absolute;
  width: 75%;
  height: 75%;
  transform: translateX(50%) translateY(-50%);
  top: 0;
  right: 0;
`;

interface CartButtonBadgeProps {
  badgeColor: string;
  visible: boolean;
}
const CartButtonBadge = styled.div<CartButtonBadgeProps>`
  display: ${(props) => (props.visible ? 'inline-block' : 'none')};
  background-color: ${(props) => props.badgeColor};
  border-radius: 50%;
  font-size: 50%;
  width: 100%;
  height: 100%;
`;

export default CartPreviewButton;
